<style>
  .button-like-link {
    background: none !important;
    border: none;
    padding: 0 !important;
    /*optional*/
    font-family: Roboto;
    /*input has OS specific font-family*/
    color: #069;
    text-decoration: underline;
    cursor: pointer;
  }
</style>

<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{'notify.list_notify' | translate}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-table [dataSource]="dataSource" class="mt-3 table-bordered">
      <!-- STT -->
      <ng-container matColumnDef="STT" class="mat-column-symbol">
        <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
          {{'enterprise_contract.table_headers.No' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                  [ngClass]="!element.status ? 'font-weight-bold' : 'font-weight-normal'"
                  (click)="updateStatus(element.id, element.status)">
          {{element.STT}}
        </mat-cell>
      </ng-container>

      <!-- Nội dung Column -->
      <!-- Change Request SCONTRACT-5290 -->
      <ng-container matColumnDef="description" class="mat-column-symbol">
        <mat-header-cell *matHeaderCellDef style="max-width: 95%" class="mat-cell-non-boder-right-bottom">
          {{'notify.content' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" style="max-width: 95%" class="mat-cell-non-boder-right-bottom"
                  [ngClass]="!element.status ? 'font-weight-bold' : 'font-weight-normal'"
                  (click)="updateStatus(element.id, element.status)">
          <div>
                <span *ngIf="element.content != ''" [innerHtml]="getContent(element)" class="fix-width notify-content">
                </span>
            <br>
            <span
              *ngIf="element.content != '' && (element.notitficationType != 90 && element.notitficationType != 5 && element.notitficationType != 6 && element.notitficationType != 7 && element.notitficationType != 8 && element.notitficationType != 75 && element.notitficationType != 76 && element.notitficationType != 77 && element.notitficationType != 78)">
                  {{'alert.notification_text' | translate}}{{element.createdTime | dateformat}}
                </span>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Tác động Column -->
      <ng-container matColumnDef="symbol" class="mat-column-symbol">
        <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col">
          {{'headertable.action' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="mat-header-cell-center action-col"
                  (click)="$event.stopPropagation();">
          <button
            *ngIf="element.notitficationType != EnumNotificationType.RESET_PASSWORD && element.notitficationType != EnumNotificationType.CREATE_ACCOUNT && element.notitficationType != EnumNotificationType.REFUND_RESOURCE
              && element.notitficationType != EnumNotificationType.CANCEL_SIGN_FLOW && element.notitficationType != EnumNotificationType.CANCEL_SIGN_APPROVE_CUSTOMER
              && element.notitficationType != EnumNotificationType.NOTIFICATION_TRANSFER_MONEY_STA_TO_SMS_SUCCESS && element.notitficationType != EnumNotificationType.NOTIFICATION_TRANSFER_MONEY_SMS_TO_STA_SUCCESS"
            mat-icon-button (click)="viewDocument(element);">
            <mat-icon color="primary" matTooltip="{{'enterprise_contract.tooltips.document_view' | translate}}">
              visibility
            </mat-icon>
          </button>
          <button mat-icon-button color="primary" (click)="deleteNotify(element.id)"
                  matTooltip="{{'notify.deleteNoti' | translate}}">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"
               (toggleChange)="onToggleChange($event,row)">
      </mat-row>
    </mat-table>

    <!-- Pagination -->
    <app-pagination [(paginate)]="paginate" (pageChange)="loadData($event.page, $event.pageSize)">
    </app-pagination>
  </mat-card-content>
</mat-card>
